<template>
    <div></div>
</template>

<script>
    export default {
        name: "empty"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/blocks/Empty.vue